// ejected using 'npx eject-keycloak-page'
import { clsx } from "keycloakify/tools/clsx";
import type { PageProps } from "keycloakify/login/pages/PageProps";
import { useGetClassName } from "keycloakify/login/lib/useGetClassName";
import type { KcContext } from "../kcContext";
import type { I18n } from "../i18n";

export default function ConfirmEmail(
  props: PageProps<
    Extract<KcContext, { pageId: "login-verify-email.ftl" }>,
    I18n
  >
) {
  const { kcContext, i18n, doUseDefaultCss, Template, classes } = props;

  const { getClassName } = useGetClassName({
    doUseDefaultCss,
    classes,
  });

  const { url } = kcContext;

  const { msg } = i18n;

  return (
    <Template
      {...{ kcContext, i18n, doUseDefaultCss, classes }}
      displayWide={true}
      headerNode={msg("doLogIn")}
    >
      <div id="kc-form" className={clsx(getClassName("kcContentWrapperClass"))}>
        <div id="kc-form-wrapper" className={"kc-form-wrapper"}>
          <span className="confirm-message">
            На ваш email направлена ссылка для подтверждения регистрации.
          </span>
        </div>

        <div style={{ marginTop: 15 }}>
          <a href={url.loginUrl}>{msg("backToLogin")}</a>
        </div>
      </div>
    </Template>
  );
}
